import React from 'react';
import { ShieldCheck, Lock, CreditCard, Zap, RefreshCw, CheckCircle } from 'lucide-react';
export function PurchaseSection() {
  const PURCHASE_LINK = 'https://pay.hotmart.com/Q104345987V?checkoutMode=10';
  return <div id="compra" className="bg-white rounded-2xl shadow-2xl border-2 border-amber-300 p-8 md:p-12 max-w-4xl mx-auto text-center relative overflow-hidden" data-id="element-28">
      {/* Top accent bar */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-400 via-green-500 to-green-400" data-id="element-29"></div>

      {/* Urgency badge */}
      <span className="inline-block bg-red-100 text-red-700 text-sm font-bold px-4 py-1.5 rounded-full mb-6 animate-pulse" data-id="element-30">
        🔥 Oferta especial por tiempo limitado
      </span>

      <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-31">
        Tu paz está a un clic de distancia
      </h2>
      <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-32">
        Ebook completo + 4 bonos gratis + acceso de por vida.
        <br data-id="element-33" />
        <strong className="text-gray-800" data-id="element-34">
          Todo lo que necesitas para encontrar respuestas hoy.
        </strong>
      </p>

      {/* Value Stack + Price section */}
      <div className="bg-amber-50 rounded-2xl p-8 mb-8 max-w-lg mx-auto border border-amber-200" data-id="element-35">
        <h3 className="font-serif font-bold text-xl text-gray-900 mb-4" data-id="element-36">
          Todo lo que recibes hoy:
        </h3>
        <ul className="space-y-2 text-left max-w-md mx-auto mb-6" data-id="element-37">
          <li className="flex justify-between text-gray-700" data-id="element-38">
            <span data-id="element-39">📖 Ebook principal</span>
            <span className="line-through text-gray-400" data-id="element-40">$27.99</span>
          </li>
          <li className="flex justify-between text-gray-700" data-id="element-41">
            <span data-id="element-42">🎁 Bono 1: Guía de oración</span>
            <span className="line-through text-gray-400" data-id="element-43">$12.99</span>
          </li>
          <li className="flex justify-between text-gray-700" data-id="element-44">
            <span data-id="element-45">🎁 Bono 2: Versículos de emergencia</span>
            <span className="line-through text-gray-400" data-id="element-46">$9.99</span>
          </li>
          <li className="flex justify-between text-gray-700" data-id="element-47">
            <span data-id="element-48">🎁 Bono 3: Rutina de 5 minutos</span>
            <span className="line-through text-gray-400" data-id="element-49">$7.99</span>
          </li>
          <li className="flex justify-between text-gray-700" data-id="element-50">
            <span data-id="element-51">🎁 Bono 4: 30 mensajes</span>
            <span className="line-through text-gray-400" data-id="element-52">$14.99</span>
          </li>
          <li className="flex justify-between font-bold text-gray-900 border-t border-amber-300 pt-3 mt-3 text-lg" data-id="element-53">
            <span data-id="element-54">Valor total:</span>
            <span className="line-through text-gray-400" data-id="element-55">$73.95</span>
          </li>
        </ul>
        <div className="text-center" data-id="element-56">
          <p className="text-sm text-gray-500 mb-1" data-id="element-57">
            Hoy lo llevas TODO por solo:
          </p>
          <span className="text-6xl font-bold text-green-600" data-id="element-58">$13.99</span>
          <div className="mt-2" data-id="element-59">
            <span className="inline-block text-sm font-bold bg-green-100 text-green-700 px-3 py-1 rounded-full" data-id="element-60">
              AHORRA MÁS DEL 80%
            </span>
          </div>
          <p className="text-sm text-gray-500 mt-2" data-id="element-61">
            Pago único. Sin suscripciones. Tuyo para siempre.
          </p>
        </div>
      </div>

      {/* Main CTA */}
      <a href={PURCHASE_LINK} className="inline-flex items-center justify-center w-full md:w-auto bg-green-600 hover:bg-green-700 text-white text-xl md:text-2xl font-bold py-5 px-14 rounded-full shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 mb-4" data-id="element-62">
        👉 Quiero acceso inmediato
      </a>

      <p className="text-sm text-gray-500 mb-8" data-id="element-63">
        ⚡ Recibes todo en tu correo en menos de 2 minutos
      </p>

      {/* Trust badges */}
      <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-600 mb-8" data-id="element-64">
        <div className="flex items-center gap-2" data-id="element-65">
          <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-66" />
          <span className="font-medium" data-id="element-67">Garantía de 7 días</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-68">
          <Lock className="w-5 h-5 text-green-600" data-id="element-69" />
          <span className="font-medium" data-id="element-70">Pago 100% Seguro</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-71">
          <Zap className="w-5 h-5 text-green-600" data-id="element-72" />
          <span className="font-medium" data-id="element-73">Acceso Instantáneo</span>
        </div>
      </div>

      {/* Guarantee box */}
      <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 max-w-lg mx-auto mb-6" data-id="element-74">
        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-75">
          <RefreshCw className="w-6 h-6 text-green-600" data-id="element-76" />
          <h4 className="font-bold text-green-800 text-lg" data-id="element-77">
            Garantía Total de 7 Días
          </h4>
        </div>
        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-78">
          Si por cualquier razón sientes que este ebook no es para ti, te
          devolvemos el <strong data-id="element-79">100% de tu dinero</strong>. Sin preguntas, sin
          complicaciones, sin letra pequeña. Tu satisfacción es lo primero.
        </p>
      </div>

      <div className="pt-4 border-t border-gray-100" data-id="element-80">
        <p className="text-xs text-gray-400" data-id="element-81">
          Tu compra está procesada por Hotmart, la plataforma de pagos digitales
          más segura de Latinoamérica. Aceptamos todas las tarjetas de crédito y
          débito.
        </p>
      </div>
    </div>;
}